import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Mail, MapPin } from 'lucide-react';
export function PrivacyPolicyPage() {
  return <div className="min-h-screen bg-white" data-id="element-1132">
      {/* Header */}
      <Header variant="dark" data-id="element-1133" />

      {/* Hero Section */}
      <section className="bg-neutral-100 py-32 px-8 mt-32" data-id="element-1134">
        <div className="max-w-4xl mx-auto text-center" data-id="element-1135">
          <div className="w-16 h-0.5 bg-brand-pink mx-auto mb-6" data-id="element-1136" />
          <h1 className="font-heading text-5xl lg:text-6xl text-neutral-900 mb-6 leading-tight" data-id="element-1137">
            Privacy Policy
          </h1>
          <p className="text-lg text-neutral-600 leading-relaxed" data-id="element-1138">
            Last updated:{' '}
            {new Date().toLocaleDateString('en-AU', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="bg-white py-20 px-8" data-id="element-1139">
        <div className="max-w-4xl mx-auto prose prose-lg" data-id="element-1140">
          {/* Introduction */}
          <div className="mb-12" data-id="element-1141">
            <p className="text-neutral-600 leading-relaxed mb-6" data-id="element-1142">
              This Privacy Policy describes how your personal information is
              collected, used, and shared when you visit or make a purchase from
              https://petersonhouse.com.au/ (the "Site").
            </p>
          </div>

          {/* Personal Information We Collect */}
          <div className="mb-12" data-id="element-1143">
            <div className="w-12 h-0.5 bg-brand-pink mb-4" data-id="element-1144" />
            <h2 className="font-heading text-3xl text-neutral-900 mb-6" data-id="element-1145">
              Personal Information We Collect
            </h2>
            <p className="text-neutral-600 leading-relaxed mb-4" data-id="element-1146">
              When you visit the Site, we automatically collect certain
              information about your device, including information about your
              web browser, IP address, time zone, and some of the cookies that
              are installed on your device. Additionally, as you browse the
              Site, we collect information about the individual web pages or
              products that you view, what websites or search terms referred you
              to the Site, and information about how you interact with the Site.
              We refer to this automatically-collected information as "Device
              Information".
            </p>
            <p className="text-neutral-600 leading-relaxed mb-4" data-id="element-1147">
              We collect Device Information using the following technologies:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-neutral-600 mb-6" data-id="element-1148">
              <li data-id="element-1149">
                <strong data-id="element-1150">"Cookies"</strong> are data files that are placed on
                your device or computer and often include an anonymous unique
                identifier. For more information about cookies, and how to
                disable cookies, visit{' '}
                <a href="http://www.allaboutcookies.org" target="_blank" rel="noopener noreferrer" className="text-brand-pink hover:text-brand-pink/80 transition-colors" data-id="element-1151">
                  http://www.allaboutcookies.org
                </a>
                .
              </li>
              <li data-id="element-1152">
                <strong data-id="element-1153">"Log files"</strong> track actions occurring on the
                Site, and collect data including your IP address, browser type,
                Internet service provider, referring/exit pages, and date/time
                stamps.
              </li>
              <li data-id="element-1154">
                <strong data-id="element-1155">"Web beacons", "tags", and "pixels"</strong> are
                electronic files used to record information about how you browse
                the Site.
              </li>
            </ul>
            <p className="text-neutral-600 leading-relaxed mb-4" data-id="element-1156">
              Additionally when you make a purchase or attempt to make a
              purchase through the Site, we collect certain information from
              you, including your name, billing address, shipping address,
              payment information (including credit card numbers), email
              address, and phone number. We refer to this information as "Order
              Information".
            </p>
            <p className="text-neutral-600 leading-relaxed" data-id="element-1157">
              When we talk about "Personal Information" in this Privacy Policy,
              we are talking both about Device Information and Order
              Information.
            </p>
          </div>

          {/* How Do We Use Your Personal Information */}
          <div className="mb-12" data-id="element-1158">
            <div className="w-12 h-0.5 bg-brand-pink mb-4" data-id="element-1159" />
            <h2 className="font-heading text-3xl text-neutral-900 mb-6" data-id="element-1160">
              How Do We Use Your Personal Information?
            </h2>
            <p className="text-neutral-600 leading-relaxed mb-4" data-id="element-1161">
              We use the Order Information that we collect generally to fulfill
              any orders placed through the Site (including processing your
              payment information, arranging for shipping, and providing you
              with invoices and/or order confirmations). Additionally, we use
              this Order Information to:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-neutral-600 mb-6" data-id="element-1162">
              <li data-id="element-1163">Communicate with you;</li>
              <li data-id="element-1164">Screen our orders for potential risk or fraud; and</li>
              <li data-id="element-1165">
                When in line with the preferences you have shared with us,
                provide you with information or advertising relating to our
                products or services.
              </li>
            </ul>
            <p className="text-neutral-600 leading-relaxed" data-id="element-1166">
              We use the Device Information that we collect to help us screen
              for potential risk and fraud (in particular, your IP address), and
              more generally to improve and optimize our Site (for example, by
              generating analytics about how our customers browse and interact
              with the Site, and to assess the success of our marketing and
              advertising campaigns).
            </p>
          </div>

          {/* Sharing Your Personal Information */}
          <div className="mb-12" data-id="element-1167">
            <div className="w-12 h-0.5 bg-brand-pink mb-4" data-id="element-1168" />
            <h2 className="font-heading text-3xl text-neutral-900 mb-6" data-id="element-1169">
              Sharing Your Personal Information
            </h2>
            <p className="text-neutral-600 leading-relaxed mb-4" data-id="element-1170">
              We share your Personal Information with third parties to help us
              use your Personal Information, as described above.
            </p>
            <p className="text-neutral-600 leading-relaxed mb-4" data-id="element-1171">
              We also use Google Analytics to help us understand how our
              customers use the Site -- you can read more about how Google uses
              your Personal Information here:{' '}
              <a href="https://www.google.com/intl/en/policies/privacy/" target="_blank" rel="noopener noreferrer" className="text-brand-pink hover:text-brand-pink/80 transition-colors" data-id="element-1172">
                https://www.google.com/intl/en/policies/privacy/
              </a>
              . You can also opt-out of Google Analytics here:{' '}
              <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer" className="text-brand-pink hover:text-brand-pink/80 transition-colors" data-id="element-1173">
                https://tools.google.com/dlpage/gaoptout
              </a>
              .
            </p>
            <p className="text-neutral-600 leading-relaxed" data-id="element-1174">
              Finally, we may also share your Personal Information to comply
              with applicable laws and regulations, to respond to a subpoena,
              search warrant or other lawful request for information we receive,
              or to otherwise protect our rights.
            </p>
          </div>

          {/* Behavioural Advertising */}
          <div className="mb-12" data-id="element-1175">
            <div className="w-12 h-0.5 bg-brand-pink mb-4" data-id="element-1176" />
            <h2 className="font-heading text-3xl text-neutral-900 mb-6" data-id="element-1177">
              Behavioural Advertising
            </h2>
            <p className="text-neutral-600 leading-relaxed mb-4" data-id="element-1178">
              As described above, we use your Personal Information to provide
              you with targeted advertisements or marketing communications we
              believe may be of interest to you. For more information about how
              targeted advertising works, you can visit the Network Advertising
              Initiative's ("NAI") educational page at{' '}
              <a href="http://www.networkadvertising.org/understanding-online-advertising/how-does-it-work" target="_blank" rel="noopener noreferrer" className="text-brand-pink hover:text-brand-pink/80 transition-colors" data-id="element-1179">
                http://www.networkadvertising.org/understanding-online-advertising/how-does-it-work
              </a>
              .
            </p>
            <p className="text-neutral-600 leading-relaxed mb-4" data-id="element-1180">
              You can opt out of targeted advertising by using the links below:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-neutral-600 mb-6" data-id="element-1181">
              <li data-id="element-1182">
                Facebook:{' '}
                <a href="https://www.facebook.com/settings/?tab=ads" target="_blank" rel="noopener noreferrer" className="text-brand-pink hover:text-brand-pink/80 transition-colors" data-id="element-1183">
                  https://www.facebook.com/settings/?tab=ads
                </a>
              </li>
              <li data-id="element-1184">
                Google:{' '}
                <a href="https://www.google.com/settings/ads/anonymous" target="_blank" rel="noopener noreferrer" className="text-brand-pink hover:text-brand-pink/80 transition-colors" data-id="element-1185">
                  https://www.google.com/settings/ads/anonymous
                </a>
              </li>
              <li data-id="element-1186">
                Bing:{' '}
                <a href="https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads" target="_blank" rel="noopener noreferrer" className="text-brand-pink hover:text-brand-pink/80 transition-colors" data-id="element-1187">
                  https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads
                </a>
              </li>
            </ul>
            <p className="text-neutral-600 leading-relaxed" data-id="element-1188">
              Additionally, you can opt out of some of these services by
              visiting the Digital Advertising Alliance's opt-out portal at:{' '}
              <a href="http://optout.aboutads.info/" target="_blank" rel="noopener noreferrer" className="text-brand-pink hover:text-brand-pink/80 transition-colors" data-id="element-1189">
                http://optout.aboutads.info/
              </a>
              .
            </p>
          </div>

          {/* Do Not Track */}
          <div className="mb-12" data-id="element-1190">
            <div className="w-12 h-0.5 bg-brand-pink mb-4" data-id="element-1191" />
            <h2 className="font-heading text-3xl text-neutral-900 mb-6" data-id="element-1192">
              Do Not Track
            </h2>
            <p className="text-neutral-600 leading-relaxed" data-id="element-1193">
              Please note that we do not alter our Site's data collection and
              use practices when we see a Do Not Track signal from your browser.
            </p>
          </div>

          {/* Your Rights */}
          <div className="mb-12" data-id="element-1194">
            <div className="w-12 h-0.5 bg-brand-pink mb-4" data-id="element-1195" />
            <h2 className="font-heading text-3xl text-neutral-900 mb-6" data-id="element-1196">
              Your Rights
            </h2>
            <p className="text-neutral-600 leading-relaxed mb-4" data-id="element-1197">
              If you are a European resident, you have the right to access
              personal information we hold about you and to ask that your
              personal information be corrected, updated, or deleted. If you
              would like to exercise this right, please contact us through the
              contact information below.
            </p>
            <p className="text-neutral-600 leading-relaxed" data-id="element-1198">
              Additionally, if you are a European resident we note that we are
              processing your information in order to fulfill contracts we might
              have with you (for example if you make an order through the Site),
              or otherwise to pursue our legitimate business interests listed
              above. Additionally, please note that your information will be
              transferred outside of Europe, including to Canada and the United
              States.
            </p>
          </div>

          {/* Data Retention */}
          <div className="mb-12" data-id="element-1199">
            <div className="w-12 h-0.5 bg-brand-pink mb-4" data-id="element-1200" />
            <h2 className="font-heading text-3xl text-neutral-900 mb-6" data-id="element-1201">
              Data Retention
            </h2>
            <p className="text-neutral-600 leading-relaxed" data-id="element-1202">
              When you place an order through the Site, we will maintain your
              Order Information for our records unless and until you ask us to
              delete this information.
            </p>
          </div>

          {/* Changes */}
          <div className="mb-12" data-id="element-1203">
            <div className="w-12 h-0.5 bg-brand-pink mb-4" data-id="element-1204" />
            <h2 className="font-heading text-3xl text-neutral-900 mb-6" data-id="element-1205">
              Changes
            </h2>
            <p className="text-neutral-600 leading-relaxed" data-id="element-1206">
              We may update this privacy policy from time to time in order to
              reflect, for example, changes to our practices or for other
              operational, legal or regulatory reasons.
            </p>
          </div>

          {/* Contact Us */}
          <div className="mb-12" data-id="element-1207">
            <div className="w-12 h-0.5 bg-brand-pink mb-4" data-id="element-1208" />
            <h2 className="font-heading text-3xl text-neutral-900 mb-6" data-id="element-1209">
              Contact Us
            </h2>
            <p className="text-neutral-600 leading-relaxed mb-6" data-id="element-1210">
              For more information about our privacy practices, if you have
              questions, or if you would like to make a complaint, please
              contact us:
            </p>

            <div className="bg-neutral-50 border border-neutral-200 p-6 rounded-none space-y-4" data-id="element-1211">
              <div className="flex items-start gap-3" data-id="element-1212">
                <Mail className="w-5 h-5 text-brand-pink mt-1 flex-shrink-0" data-id="element-1213" />
                <div data-id="element-1214">
                  <p className="text-neutral-900 font-medium mb-1" data-id="element-1215">Email</p>
                  <a href="mailto:bubbles@petersonhouse.com.au" className="text-brand-pink hover:text-brand-pink/80 transition-colors" data-id="element-1216">
                    bubbles@petersonhouse.com.au
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-3" data-id="element-1217">
                <MapPin className="w-5 h-5 text-brand-pink mt-1 flex-shrink-0" data-id="element-1218" />
                <div data-id="element-1219">
                  <p className="text-neutral-900 font-medium mb-1" data-id="element-1220">Mail</p>
                  <p className="text-neutral-600 leading-relaxed" data-id="element-1221">
                    Peterson House
                    <br data-id="element-1222" />
                    Peterson House Ltd
                    <br data-id="element-1223" />
                    Corner Broke Road and Wine Country Drive
                    <br data-id="element-1224" />
                    Pokolbin NSW 2320
                    <br data-id="element-1225" />
                    Australia
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer data-id="element-1226" />
    </div>;
}